import { render, staticRenderFns } from "./index-Init.vue?vue&type=template&id=5c4862a1&scoped=true"
import script from "./index-Init.vue?vue&type=script&lang=js"
export * from "./index-Init.vue?vue&type=script&lang=js"
import style0 from "./index-Init.vue?vue&type=style&index=0&id=5c4862a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4862a1",
  null
  
)

export default component.exports